export default "__VITE_ASSET__DYN4QEnm__"